export default __webpack_public_path__ + "static/media/jaipurpackage.84a8788d.jpeg";